import React from "react";
import { Button } from "../../pages/home/components/HeroSession.js/HeroSession.styles";
import { FormContainer, InputContainer } from "../betaForm/BetaDetail";

const SchoolFeeDetail = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>Where do you work currently?</label>
          <input placeholder="eg Coca Cola" />
        </div>
        <div>
          <label>Monthly Salary?</label>
          <input placeholder="eg 500,000" />
        </div>
        <div>
          <label>Number of Children</label>
          <input placeholder="eg, 2 children" />
        </div>
        <div>
          <label>Amount you wish to borrow?</label>
          <input placeholder="eg, 400,000" />
        </div>
        <div>
          <label>Name of School</label>
          <input placeholder="eg, University of Lagos" />
        </div>
        <div>
          <label>Your child is in what level?</label>
          <input placeholder="eg, Final year" />
        </div>
      </InputContainer>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/fee"
        >
          Finish
        </Button>
      </div>
    </FormContainer>
  );
};

export default SchoolFeeDetail;
